import Alert from "components/alert";
import Modal from "components/modal";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import useAuthStore from "store/auth";

export default function PublicPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isLogin = useAuthStore((state) => state.isLogin);
  const subTxt = !isLogin && pathname === "/" ? t("login_ttl") : "회원가입";
  return (
    <>
      <div className="out-let">
        <div className="_left">
          <div
            className="text-5xl py-8 cursor-pointer"
            onClick={() => navigate("/")}
          >
            Manager
          </div>
          <div className="text-3xl">{subTxt}</div>
        </div>
        <div className="_right">
          <Outlet />
        </div>
        <Modal />
        <Alert />
      </div>
    </>
  );
}
